"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.string.bold.js");

require("core-js/modules/es.object.assign.js");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

require("./TextFormat.less");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["children", "breakWord", "bold", "muted", "info", "success", "warning", "error", "danger", "type"];
var _default = TextFormat;
/**
 * @name TextFormat
 */

exports.default = _default;

function TextFormat(_ref) {
  var children = _ref.children,
      breakWord = _ref.breakWord,
      bold = _ref.bold,
      muted = _ref.muted,
      info = _ref.info,
      success = _ref.success,
      warning = _ref.warning,
      error = _ref.error,
      danger = _ref.danger,
      type = _ref.type,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("span", Object.assign({
    className: (0, _classnames.default)('TextFormat', type ? "TextFormat--".concat(type) : null, {
      'TextFormat--break-word': breakWord,
      'TextFormat--bold': bold,
      'TextFormat--muted': muted,
      'TextFormat--info': info,
      'TextFormat--success': success,
      'TextFormat--warning': warning,
      'TextFormat--error': error,
      'TextFormat--danger': danger
    })
  }, rest), children);
}